import { React } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { isAuthenticated } from "../../services";
import { SIGN_IN } from "../../constants/routes";

function RequireAuth({ children }) {
  if (!isAuthenticated()) {
      return <Navigate to={SIGN_IN} replace />
  }
  return <Outlet />;
}

export default RequireAuth;